import React from "react";
import { CheckCircle2 } from "lucide-react";

const benefits = [
  { t: "Większą kontrolę nad firmą", d: "Wiesz co się dzieje, wiesz gdzie płyną pieniądze." },
  { t: "Lepszą rentowność", d: "Marże, które pozwalają budować — nie tylko przetrwać." },
  { t: "Uporządkowane procesy", d: "Firma działa nawet wtedy, gdy Ciebie nie ma." },
  { t: "Mniej stresu i chaosu", d: "Spokojniejszy sen i jaśniejsza głowa każdego dnia." },
  { t: "Realne decyzje zamiast zgadywania", d: "Dane, liczby i doświadczenie — nie intuicja." },
];

export default function Benefits() {
  return (
    <section id="korzysci" data-testid="benefits-section" className="section relative">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="eyebrow">Efekty współpracy</span>
          <h2 className="h-display mt-4 text-[clamp(28px,3.6vw,44px)]">
            Co <span className="gold-gradient-text italic">zyskujesz</span>
          </h2>
          <div className="gold-line mt-6" />
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-8">
          {benefits.map((b, idx) => (
            <div
              key={b.t}
              data-testid={`benefit-${idx}`}
              className="flex gap-6 items-start border-b border-[rgba(212,169,74,0.12)] pb-7 group"
            >
              <CheckCircle2
                size={28}
                strokeWidth={1.3}
                className="text-[var(--gold)] mt-1 shrink-0 group-hover:scale-110 transition-transform"
              />
              <div className="flex-1">
                <h3 className="font-display text-[22px] md:text-[24px] text-[#f5f1e8]">
                  {b.t}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#b8b3a7]">
                  {b.d}
                </p>
              </div>
              <span className="font-display text-[14px] tracking-[0.3em] text-[var(--gold)] opacity-70">
                0{idx + 1}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
